import React from "react";
import { Switch, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../layouts/NonAuthLayout";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected, AccessRoute } from "./AuthProtected";

const Routes = () => {
  const availablePublicRoutesPaths = publicRoutes.map((r) => r.path);
  const availableAuthRoutesPath = authProtectedRoutes.map((r) => r.path);
  return (
    <React.Fragment>
      <Switch>
        <Route path={availablePublicRoutesPaths}>
          <NonAuthLayout>
            <Switch>
              {publicRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  component={route.component}
                  key={idx}
                  exact={true}
                />
              ))}
            </Switch>
          </NonAuthLayout>
        </Route>

        <Route path={availableAuthRoutesPath}>
          <AuthProtected>
            <Switch>
              {authProtectedRoutes.map((route, idx) => (
                <AccessRoute
                  path={route.path}
                  component={route.component}
                  key={idx}
                  exact={true}
                  layout={route.layout}
                  roles={route.roles}
                />
              ))}
            </Switch>
          </AuthProtected>
        </Route>
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
